<script lang="ts">
  import widgetStore from '../store/widget';
  import sessionStore from '../store/session';
  import authStore from '../store/auth';
  import callStore from '../store/call';
  import Modal from './Modal.svelte';
  import { CALL_STATE_CONSTANTS, formatter, ICONS, pickOutInitials } from '../services/utils'
  import { useNavigate } from 'svelte-navigator'
  import type { Profile } from '../types/session'
  import { fly } from 'svelte/transition'
  import { backOut } from 'svelte/easing'
  import { useQuery } from '@sveltestack/svelte-query';
  import { generateOauthUrl, getOauthStatus } from '../domain/session/profile.action';
  import toast from '../services/toast';
  import Icon from './Icon.svelte';
  import { measureLatency } from '../domain/call/networkbar.action.ts';
  import { onMount } from 'svelte';
  

  
  const navigate = useNavigate();
  const { logo } = $widgetStore;
  let numbers: Array<Profile | any> = $sessionStore.receivers || []
  let profile: Profile | any = $sessionStore.profile || {}
  let dropdown = null
  let oauth_url;
  let showConnectionNotification = true;
  let tracker;
  let averageLag = 0;
  let currentLag = 0;
  let pollingInterval;


  const HAS_CRM_LINKED = useQuery('has_crm_linked', getOauthStatus, {
      refetchInterval: 1000 * 60,
      enabled: !$sessionStore.is_app_connected,
  });
  $HAS_CRM_LINKED;


  const startTracking = () => {

      if (!tracker) {
          tracker = new measureLatency();
      }

      pollingInterval = setInterval(() => {
          if (tracker) {
              averageLag = tracker.getAverageLag();
              currentLag = tracker.getCurrentLag();
          }
      }, 5000);
  };

  let showNetworkBarModal = false;

  const openNetworkBarModal = () => (showNetworkBarModal = true);
  const closeNetworkBarModal = () => (showNetworkBarModal = false);

  onMount(() => {
    startTracking();

    const logInterval = setInterval(() => {}, 5000);


  });

  

  $: {
    if (!$sessionStore.is_app_connected) {
      generateOauthUrl().then((url) => {
          oauth_url = url;
      });
    }
  }

  const handleNumberSelection = (receiver) => {
    sessionStore.setReceiver(receiver);
    return null;
  }

  const handleClick = () => {
    navigate("/choose-business")
  }

  const handleLogout = () => {
    sessionStore.logout()
    authStore.logout()
    navigate("/login")
  }

  const connectApp = () => {
    if ($sessionStore.is_app_connected) {
      toast.success("App is already connected!")
      return;
    }
    if (!$authStore.user.id) {
      toast.warn('We need your complete profile. Kindly refresh!')
      return;
    }
    window.open(oauth_url, '_blank');
  }

  $: {
    setTimeout(() => {
      if(showConnectionNotification === $callStore.sipConnected) {
        showConnectionNotification = $callStore.sipConnected;
        if ($callStore.sipConnected) {
          setTimeout(() => {
            showConnectionNotification = false;
          }, 3000);
        }
      }
    }, 2000);
  }

  const getNetworkStatus = (lag) => {
    if (!$callStore.sipConnected) {
      return 'bad-network';
    }

    if (lag < 200) {
      return 'good-network';
    } else if (lag >= 200 && lag < 300) {
      return 'average-network';
    } else {
      return 'bad-network';
    }
  }

  const getNetworkTextColor = (networkStatus) => {
    if (!$callStore.sipConnected) {
      return 'red';
    }
    
    if (networkStatus === 'good-network') {
      return 'green'
    }
    else if (networkStatus === 'average-network') {
      return '#EA9704';
    } else {
      return 'red';
    }
  }



</script>

{#if showConnectionNotification}
<div class="py-1 text-white text-center text-xs {$callStore.sipConnected ? 'bg-green-700' : 'bg-red-700'}">
  { $callStore.sipConnected ? 'Connected' : 'Connect to the internet to make calls'}
</div>
{/if}
<div class="py-2 px-3 rounded-full shadow-xl shadow-blue-100/50 flex mx-4 my-3 justify-between">
  <div class="flex" >
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="logo-container" on:click={() => dropdown = dropdown ? null : 1}>
      <div class="logo">
        {#if logo}
          <img src={logo} width="40px" alt="logo" />
        {:else}
          <img src={ICONS.logo} width="40px" alt="logo" />
        {/if}
      </div>
    </div>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="ml-3 cursor-pointer" on:click={() => dropdown = dropdown ? null : 1}>
      <p class="text-sm font-light text-gray-500 flex items-center">{ $sessionStore.receiver?.business_number?.phone_number || 'n/a' } &nbsp;<Icon icon="toggle"/></p>
      <strong class="text-sm">{ formatter.format( $sessionStore.profile?.business?.balance || 0 ) }<strong>
    </div>
  </div>

  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="flex items-center">
    <div 
      class="mr-3"
    >
      {#if [
          CALL_STATE_CONSTANTS.OUTGOING, 
          CALL_STATE_CONSTANTS.RINGING,
          CALL_STATE_CONSTANTS.INCALL,
          CALL_STATE_CONSTANTS.OUTCALL
      ].includes($callStore.state)}
        <div on:click={() => navigate("/call")} class="{$callStore.sipConnected ? 'bg-green-500' : 'bg-red-500'} py-1 px-2 rounded-md animate-flicker">
          <Icon icon="ringing-filled" color="#fff" size=12 />
        </div>
      {:else}

        <span 
          class="tooltip {getNetworkStatus(Math.round(averageLag))}" 
          on:click={openNetworkBarModal}>
          <Icon icon={getNetworkStatus(Math.round(averageLag))} />
          <span class="tooltiptext" style="color: {getNetworkStatus(Math.round(averageLag))};">{Math.round(averageLag)} ms</span>
        </span>

          {#if showNetworkBarModal}
          <div style="position: fixed; z-index: 1000; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: start;">

            <Modal onClose={closeNetworkBarModal} >
              <div>
                <p style="color: #1D2739; font-size: 14px;">Average ping: <span style="color: {getNetworkTextColor(getNetworkStatus(Math.round(averageLag)))}; font-size: 16px; font-weight: bolder;"><strong>{Math.round(averageLag)} ms</strong></span></p>
                <p style="color: #1D2739; font-size: 14px;">Last ping: <span style="color: {getNetworkTextColor(getNetworkStatus(Math.round(currentLag)))}; font-size: 16px;"><strong>{Math.round(currentLag)} ms</strong></span></p>
                <p style="color: #1D2739; font-size: 14px;">Outbound packet loss rate: <span style="font-size: 16px;">0.00%</span></p>
                <p style="color: #475367; margin-top: 16px; font-size: 12px;">
                  You may experience delays if your ping exceeds 250 ms 
                  or notice choppy/robotic audio if your packet loss rate exceeds 10%. 
                  If issues persist, try disconnecting and reconnecting.
                </p>
              </div>
              <div class="flex justify-between items-center mt-4">
                <span class="text-xs text-gray-500 flex items-center">
                  🔒 Secure connection
                </span>
              </div>
            </Modal>
          </div>

          {/if}
          
        
      {/if}
    </div>
    <div 
      class="cursor-pointer rounded-full flex justify-center items-center primary-bg-color w-10 h-10 text-white font-bold" 
      on:click={() => dropdown = dropdown ? null : 2}
    >
      { pickOutInitials(`${profile?.first_name || ''} ${profile?.last_name}`) }

    </div>
  </div>
</div>
{#if dropdown}
<div class="absolute w-full z-20 top-0 bottom-0 bg-gray-700/50" transition:fly>
  {#if dropdown === 1}
    <div class="p-4 rounded-lg m-4 shadow-xl bg-white" in:fly={{
      y: -100,
      delay: 100,
      easing: backOut
    }} style="overflow: hidden;">
      <div class="flex justify-between w-full items-center">
        <span class="text-black">Switch Number</span>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="p-1 border border-gray-300 rounded-md cursor-pointer" on:click={() => dropdown = null}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.75684 13.2426L13.2421 4.75736" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.2421 13.2426L4.75684 4.75735" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>        
        </span>
      </div>

      {#if numbers.length > 0}
        <div class="flex flex-col overflow-y-scroll" style="max-height: 30vh;">
            <ul>
                {#each numbers as receiver}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <li class="flex justify-between items-center my-3 py-2" on:click={() => handleNumberSelection(receiver)}>
                        <div>
                            <div class="text-xs text-gray-500">
                                { receiver.business_number.country_code } MOBILE NUMBER . 
                                { receiver.business_number.label }
                            </div>
                            <div class="flex text-gray-900">
                                {#if receiver.business_number.country_code === "NG"}
                                <img src={ICONS.ng} alt="ng-logo" width="20px" style="height: 20px"  /> 
                                {:else if receiver.business_number.country_code === "US"}
                                <img src={ICONS.us} alt="us-logo" width="20px" style="height: 20px"  /> 
                                {:else}
                                <img src={ICONS.logo} alt="pressone-logo" width="20px" style="height: 20px"  /> 
                                {/if}
                                &nbsp;
                                { receiver.business_number.phone_number }
                            </div>
                        </div>
                        <div>
                          {#if $sessionStore.receiver?.business_number?.phone_number === receiver.business_number.phone_number}
                            <Icon icon="checkbox" />
                          {/if}
                            <!-- <input type="radio" checked={$sessionStore.receiver?.business_number?.phone_number === receiver.business_number.phone_number} name="business_selection" /> -->
                        </div>
                    </li>
                {/each}
            </ul>
        </div>
      {:else}
        <div class="mb-4 text-xs text-center mt-4">
            No business number
        </div>
      {/if}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <span class="text-xs underline font-lighter cursor-pointer" on:click={handleClick}>change business</span>
    </div>
  {/if}

  {#if dropdown === 2}
    <div class="rounded-lg m-4 shadow-xl bg-white" in:fly={{
      y: -100,
      delay: 100,
      easing: backOut
    }} style="overflow: hidden;">
      <div class="p-4 bg-gray-100">
        <div class="flex justify-between w-full items-center">
          <div class="flex">
            <div class="text-sm ml-1">
              <p>{`${profile.first_name} ${profile.last_name}`}</p>
              <span class="text-xs">{ profile.business.name }</span>
            </div>
          </div>
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span class="p-1 border border-gray-300 rounded-md cursor-pointer" on:click={() => dropdown = null}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.75684 13.2426L13.2421 4.75736" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.2421 13.2426L4.75684 4.75735" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>        
          </span>
        </div>

        <div class="text-xs mt-4 mb-1 flex justify-between">
          <button class="rounded-full px-4 py-2 text-xs bg-white text-gray-700 border" on:click={() => navigate("/profile")}>View your profile</button>

          {#if process.env.APP_PROJECT_TYPE?.toLowerCase() === "zoho"}
          <button class="rounded-full px-4 py-2 text-xs bg-white text-gray-700 border flex justify-between items-center" on:click={connectApp}>
            <div class="flex justify-center items-center bg-gradient-to-r {$sessionStore.is_app_connected ? 'from-green-400 to-blue-500' : 'from-red-400 to-pink-500'} rounded-full h-2 w-2 text-white mr-2"></div>
            {#if $sessionStore.is_app_connected}
              Disconnect  
            {:else}
              Connect
            {/if}
          </button>
          {/if}
        </div>
      </div>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="p-4 flex items-center" on:click={handleLogout}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.41699 6.30001C7.67533 3.30001 9.21699 2.07501 12.592 2.07501H12.7003C16.4253 2.07501 17.917 3.56668 17.917 7.29168V12.725C17.917 16.45 16.4253 17.9417 12.7003 17.9417H12.592C9.24199 17.9417 7.70033 16.7333 7.42533 13.7833" stroke="#FF3B30" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12.4999 10H3.0166" stroke="#FF3B30" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.87467 7.20831L2.08301 9.99998L4.87467 12.7916" stroke="#FF3B30" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>          
        <span class="text-red-600 ml-1">Log out</span>
      </div>
    </div>
  {/if}
</div>
{/if}
<style lang="scss">

  .logo {
    background-color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    /* border: solid 5px lightblue; */
    position: relative;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    overflow: hidden;
    &::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 50px;
      padding: 4px; /* control the border thickness */
      background: linear-gradient(45deg, color-mix(in srgb, var(--primary-bg-color) 50%, white), var(--primary-bg-color));
      -webkit-mask: 
          linear-gradient(#fff 0 0) content-box, 
          linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
              mask-composite: exclude;
      pointer-events: none;
    }
  }

  .logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--primary-bg-color);
    font-family: 'Recoleta';
    font-weight: 500;
    font-size: 14px;
    position: relative;
    width: 41px;
    height: 41px;
    border-radius: 50%;
    border-bottom-left-radius: 2px;
  }
  .primary-bg-color {
      background-color: var(--primary-bg-color)
  }

  /* Tooltip container */
  .tooltip {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }

  /* Tooltip text */
  .tooltip .tooltiptext {
    visibility: hidden;
    width: 80px; /* Smaller width */
    color: #fff;
    text-align: center;
    border-radius: 4px;
    padding: 1px;
    position: absolute;
    z-index: 1;
    bottom: 150%;
    left: 50%;
    margin-left: -40px;
    opacity: 0;
    transition: opacity 0.1s ease-in-out;
    font-size: 12px;
  }

  /* Tooltip arrow */
  .tooltip .tooltiptext::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent transparent transparent;
  }

  /* Show the tooltip when hovering */
  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  /* Background color for good network */
  .tooltip.good-network .tooltiptext {
    background-color: green;
  }

  .tooltip.good-network .tooltiptext::after {
    border-color: green transparent transparent transparent;
  }
  
  /* Average network (yellow) */
  .tooltip.average-network .tooltiptext {
    background-color: #EA9704;
  }
  
  .tooltip.average-network .tooltiptext::after {
    border-color: #EA9704 transparent transparent transparent;
  }

  /* Background color for bad network */
  .tooltip.bad-network .tooltiptext {
    background-color: red;
  }

  .tooltip.bad-network .tooltiptext::after {
    border-color: red transparent transparent transparent;
  }

</style>
